module.exports = __webpack_public_path__ + "static/media/down-arrow.78df972d.svg";